import EditPencil from "./EditPencil";
import FunCardIcon from "./FunCardIcon";
import TownIcon from "./TownIcon";
import WorkExampleIcon from "./WorkExampleIcon";
import AddIconGradient from "./AddIconGradient";

const CustomizeIcons = {
  EditPencil,
  FunCardIcon,
  TownIcon,
  WorkExampleIcon,
  AddIconGradient,
};

export default CustomizeIcons;
